module.exports = __webpack_public_path__ + "img/bg-main-dark.d2c17886.svg";